import { render, staticRenderFns } from "./articleView.component.vue?vue&type=template&id=b4a67318&scoped=true&"
import script from "./articleView.component.vue?vue&type=script&lang=js&"
export * from "./articleView.component.vue?vue&type=script&lang=js&"
import style0 from "./articleView.component.vue?vue&type=style&index=0&id=b4a67318&lang=scss&scoped=true&"
import style1 from "./articleView.component.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a67318",
  null
  
)

export default component.exports